import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { useSpecificUseStore } from "../../../hooks/useSpecificUseStore";

const columns = [
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
];

export const SpecificUsesModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, useSelected, clearState } = props;

    const { getSpecificUsesByUse } = useSpecificUseStore();

    const [loading, setLoading] = useState(false);
    const [specificUses, setSpecificUses] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getSpecificUsesByUseApi()
    },[])

    const getSpecificUsesByUseApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSpecificUsesByUse(search, useSelected.id);
            if(!response){
                setSpecificUses([]);
                setLoading(false);
                return false;
            }else{
                setSpecificUses(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificUsesByUseApi(term)}, 1000)
        )
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md">
            <ModalHeader
                text={'Usos específicos'}
                className='positionElements'
                onCancel={closeModal}
                clearState = {clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Grid container sx={{padding:'20px'}}>
                    <Grid item container xs={12} spacing={2}>
                        <CustomTable 
                            disabled_title
                            columns={columns} 
                            loading={loading}
                            rows={specificUses || []}
                            onRowClick={() => {}}
                            onSearch={onSearch}
                            RowsPerPage={5}
                            dense
                        />
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}